import { checkAuthorization } from "./authorize";

function authorize($injector) {
	return {
		restrict: "A",
		multiElement: true,
		scope: {
			authorizePattern: "<",
			authorizeAction: "<",
			authorizeActionOrPattern: "<",
			authorizeActionScope: "<"
		},
		link: function(scope, element) {
			const securityService = $injector.get("securityService");

			const isAllowed = checkAuthorization(securityService, {
				authorizePattern: scope.authorizePattern, 
				authorizeAction: scope.authorizeAction, 
				authorizeActionOrPattern: scope.authorizeActionOrPattern, 
				authorizeActionScope: scope.authorizeActionScope 
			});

			if(isAllowed === false) {
				element.remove();
			}
		}
	};
}

function notAuthorized($injector) {
	return {
		restrict: "A",
		multiElement: true,
		scope: {
			authorizePattern: "<",
			authorizeAction: "<",
			authorizeActionOrPattern: "<",
			authorizeActionScope: "<"
		},
		link: function(scope, element) {
			const securityService = $injector.get("securityService");

			const isAllowed = checkAuthorization(securityService, {
				authorizePattern: scope.authorizePattern, 
				authorizeAction: scope.authorizeAction, 
				authorizeActionOrPattern: scope.authorizeActionOrPattern, 
				authorizeActionScope: scope.authorizeActionScope 
			});

			if(isAllowed === true) {
				element.remove();
			}
		}
	};
}

const authorizeAttribute = angular
	.module("vesl.behaviors.authorize.directive", [])
	.directive("ifAuthorized", authorize)
	.directive("ifUnauthorized", notAuthorized)
	.name;

export { authorizeAttribute };
